export const NAV_DRAWER = 'NAV_DRAWER'
export const CLOSE_BUTTON_SHOW = 'CLOSE_BUTTON_SHOW'
export const CLOSE_BUTTON_ALL = 'CLOSE_BUTTON_ALL'
export const LANGUAGE = 'LANGUAGE'
export const ENTRARLOGIN = 'ENTRARLOGIN'
export const ENTRAR_WINDOW = 'ENTRAR_WINDOW'



// WEBPACK FOOTER //
// ./src/store/actions/navigation.js